// import Swiper JS
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/css';

export default () => {
  document.querySelectorAll('[component="hotel-rooms-slider"]').forEach((cardListItem) => {
    const swiperElement = cardListItem.querySelector('.swiper');
    const arrowLeft = cardListItem.querySelector('[child="overview-arrow-left"]');
    const arrowRight = cardListItem.querySelector('[child="overview-arrow-right"]');

    const swiper = new Swiper(swiperElement, {
      loop: false,
      freeMode: {
        enabled: true,
        momentum: true,
        sticky: true,
      },
      slidesPerView: 'auto',
      spaceBetween: 20,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: arrowRight,
        prevEl: arrowLeft,
      },
      breakpoints: {
        1100: {
          slidesPerView: 4,
        },
        800: {
          slidesPerView: 3,
        },
        500: {
          slidesPerView: 2,
        },
      },
    });

    // arrowRight.addEventListener('click', () => {
    //   swiper.slideNext();
    // });

    // arrowLeft.addEventListener('click', () => {
    //   swiper.slidePrev();
    // });
  });
};
